<div class="dados-gerais-prestador-container">
    <form [formGroup]="form">
        <app-card-content [border]="false" [headerColor]="true" icon="pi pi-building" title="Dados Gerais" subtitle="Dados cadastrais do prestador">
            <div card-header class="flex items-center gap-2">
                @if (diasRestantes !== null) {
                    <span class="text-sm font-semibold px-2 py-1 rounded" [class.text-blue-600]="diasRestantesPositivo" [class.bg-blue-50]="diasRestantesPositivo" [class.text-red-500]="!diasRestantesPositivo">
                        {{ diasRestantesDescricao }}: {{ diasRestantes }} {{ diasRestantes === 1 ? 'dia' : 'dias' }}
                    </span>
                }
                <app-botao-acoes label="Ações" [iconPos]="EInconPos.LEFT" [items]="itensAcoes" [destaque]="itensEdicao" [destaqueAtivo]="isEditing" [iconColumns]="2" [permissaoUf]="pessoa()?.uf ?? null" />
            </div>

            <div class="flex flex-col gap-4">
                @if (alertasAtivos.length > 0) {
                    <!-- Cores no SCSS, e não em utilitários `amber-*`: a paleta do Tailwind é fixa e
                         não acompanha o tema, então o creme claro do fundo permanecia igual no modo
                         escuro. -->
                    <div class="pendencias flex flex-col gap-2 rounded p-3">
                        <div class="pendencias-titulo flex items-center gap-2 font-semibold">
                            <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
                            <span>Pendências do prestador</span>
                        </div>
                        <ul class="pendencias-lista list-disc pl-6 text-sm">
                            @for (mensagem of alertasAtivos; track mensagem) {
                                <li>{{ mensagem }}</li>
                            }
                        </ul>
                    </div>
                }
                <app-card-content [headerColor]="true" icon="pi pi-id-card" title="Identificação">
                    <div class="grid grid-cols-1 md:grid-cols-12 gap-4 mb-3">
                        <div class="col-span-12 md:col-span-3">
                            <label class="font-semibold block mb-2">CRM</label>
                            <input
                                pInputText
                                formControlName="crm"
                                class="w-full"
                                [pTooltip]="crmBloqueadoPorRJ ? 'Alteração de CRM não é permitida para prestadores do RJ, pois a numeração possui dígito verificador.' : undefined"
                                tooltipPosition="top"
                            />
                            @if (isEditing && crmBloqueadoPorRJ) {
                                <small class="text-color-secondary">CRM não pode ser alterado para prestadores do RJ.</small>
                            }
                            @if (isEditing && !crmBloqueadoPorRJ && crmVerificando()) {
                                <small class="text-color-secondary">Verificando disponibilidade...</small>
                            }
                            @if (isEditing && !crmBloqueadoPorRJ && !crmVerificando() && crmDisponibilidade() === 'disponivel') {
                                <small class="text-green-600">CRM disponível!</small>
                            }
                            @if (isEditing && !crmBloqueadoPorRJ && !crmVerificando() && crmDisponibilidade() === 'indisponivel') {
                                <small class="text-red-500">CRM já está em uso!</small>
                            }
                        </div>
                        <div class="col-span-12 md:col-span-2">
                            <label class="font-semibold block mb-2">UF</label>
                            <input pInputText formControlName="uf" class="w-full" />
                        </div>
                        <div class="col-span-12 md:col-span-2">
                            <label class="font-semibold mb-2 flex items-center gap-1"
                                >Cls
                                <i class="pi pi-info-circle text-xs cursor-help" pTooltip="Código da classificação do prestador." tooltipPosition="top"></i>
                            </label>
                            <input pInputText formControlName="cls" class="w-full" />
                        </div>
                        <div class="col-span-12 md:col-span-5">
                            <app-form-date-picker [control]="dataInscricao" [id]="'dataInscricao'" [label]="'Data de Inscrição'"></app-form-date-picker>
                        </div>
                    </div>

                    <div class="flex flex-wrap gap-4 mb-3">
                        <div class="flex-1 min-w-fit md:w-full">
                            <label class="font-semibold block mb-2">Razão Social</label>
                            <input pInputText formControlName="razaoSocial" class="w-full" />
                        </div>
                    </div>

                    <div class="grid grid-cols-1 md:grid-cols-12 gap-4 mb-3">
                        <div class="col-span-12 md:col-span-6">
                            <label class="font-semibold block mb-2">Nome Fantasia</label>
                            <input pInputText formControlName="nomeFantasia" class="w-full" />
                        </div>
                        <div class="col-span-12 md:col-span-6">
                            <label class="font-semibold block mb-2">Nome Usual</label>
                            <input pInputText formControlName="nomeUsual" class="w-full" />
                        </div>
                    </div>
                </app-card-content>

                <!-- Incrição -->
                <app-card-content [headerColor]="true" icon="pi pi-list-check" title="Inscrição">
                    <div class="flex flex-wrap gap-4">
                        <div class="flex-1 min-w-fit">
                            <label class="font-semibold block mb-2">
                                @if (isLabelResumo) {
                                    {{ labelsResumo['tipoInscricao']['resumo'] }}
                                } @else {
                                    {{ labelsResumo['tipoInscricao']['full'] }}
                                }
                            </label>
                            <p-select appendTo="body" [options]="opcoesTipoInscricao" formControlName="idTipoInscricao" optionLabel="label" optionValue="value" placeholder="Selecione" styleClass="w-full" />
                        </div>
                        <div class="flex-1 min-w-fit">
                            <label class="font-semibold block mb-2">Modalidade</label>
                            <p-select appendTo="body" formControlName="modalidade" [options]="opcoesModalidade" optionLabel="label" optionValue="value" placeholder="Selecione" styleClass="w-full" />
                        </div>
                        <div class="flex-1 min-w-fit">
                            <label class="font-semibold block mb-2">Situação</label>
                            <p-select appendTo="body" formControlName="idSituacao" [options]="opcoesSituacaoFiltradas" optionLabel="label" optionValue="value" placeholder="Selecione" styleClass="w-full" />
                        </div>
                        <app-form-date-picker [control]="dataSituacao" [id]="'dataSituacao'" [label]="'Dt. Situação'" [customClass]="'min-w-[125px] flex-grow flex-1 md:w-full'"> </app-form-date-picker>
                    </div>
                </app-card-content>

                <app-card-content [headerColor]="true" icon="pi pi-tags" title="Classificação">
                    <div class="grid grid-cols-1 md:grid-cols-12 gap-4 mb-3">
                        <div class="col-span-12 md:col-span-7">
                            <label class="font-semibold block mb-2">Filtro da Classificação</label>
                            <p-select appendTo="body" formControlName="filtroClassificacao" [options]="opcoesFiltroClassificacao" optionLabel="label" optionValue="value" class="w-full" />
                        </div>
                    </div>

                    <div class="grid grid-cols-1 md:grid-cols-12 gap-4 mb-3">
                        <div class="col-span-12 md:col-span-7">
                            <label class="font-semibold block mb-2">Classificação</label>
                            <p-select appendTo="body" formControlName="idClassificacao" [options]="opcoesClassificacaoFiltradas" optionLabel="label" optionValue="value" class="w-full" />
                        </div>
                        <div class="col-span-12 md:col-span-5">
                            <label class="font-semibold mb-2 flex items-center gap-1"
                                >Esp. Ênfase
                                <i class="pi pi-info-circle text-xs cursor-help" pTooltip="Especialidade cadastrada como ênfase do prestador (somente leitura)." tooltipPosition="top"></i>
                            </label>
                            <input pInputText formControlName="especialidadeEnfase" class="w-full" />
                        </div>
                    </div>

                    <div class="grid grid-cols-1 md:grid-cols-12 gap-4 mb-3">
                        <div class="col-span-12 md:col-span-6">
                            <label class="font-semibold block mb-2">Porte/Tipo</label>
                            <p-select appendTo="body" formControlName="classificacaoDetalhe" [options]="opcoesClassificacaoDetalheFiltradas" optionLabel="label" optionValue="value" class="w-full" placeholder="Selecione" />
                        </div>
                        <div class="col-span-12 md:col-span-6">
                            <label class="font-semibold block mb-2">Subtipo</label>
                            <p-select appendTo="body" formControlName="idClassificacaoSubtipo" [options]="opcoesClassificacaoSubtipoFiltradas" optionLabel="label" optionValue="value" class="w-full" placeholder="Selecione" />
                        </div>
                    </div>
                </app-card-content>

                <app-card-content [headerColor]="true" icon="pi pi-bookmark" title="Categoria">
                    <div class="flex flex-wrap gap-4 mb-3">
                        <div class="flex-1 w-full">
                            <label class="font-semibold block mb-2">Categoria</label>
                            <p-select appendTo="body" formControlName="categoria" [options]="opcoesCategoria" optionLabel="label" optionValue="value" placeholder="Selecione" styleClass="w-full" />
                        </div>
                    </div>
                </app-card-content>

                <app-card-content [tone]="certificadoDanger ? 'danger' : 'primary'" [headerColor]="true" icon="pi pi-verified" title="Certificado">
                    @if (certificadoTag; as cert) {
                        <p-tag class="mb-3 inline-flex" [value]="cert.short" [severity]="cert.severity" [rounded]="true" />
                    }
                    <div class="flex flex-wrap gap-4 mb-3">
                        <app-form-date-picker [control]="dataRenovacao" [id]="'dataRenovacao'" [label]="'Dt. Renovação'"> </app-form-date-picker>
                        <app-form-date-picker [control]="validadeCertificado" [id]="'validadeCertificado'" [label]="'Val. Certificado'"></app-form-date-picker>
                    </div>
                </app-card-content>

                <app-card-content [headerColor]="true" icon="pi pi-dollar" title="Capital Social">
                    <div class="flex flex-wrap gap-4 mb-3">
                        <div class="flex-grow md:flex-1">
                            <label class="font-semibold mb-2 flex items-center gap-1"
                                >Capital Social
                                <i class="pi pi-history text-xs cursor-pointer" pTooltip="Histórico" tooltipPosition="top" (click)="abrirHistoricoCapitalSocial('P')"></i>
                            </label>
                            <p-input-number formControlName="capitalSocial" inputId="capitalSocial" mode="currency" currency="BRL" locale="pt-BR" class="w-full" />
                        </div>
                        <app-form-date-picker [control]="capitalSocialAtualizacao" [label]="'Dt. Atualização'" [id]="'capitalSocialAtualizacao'"></app-form-date-picker>
                        <div class="flex-grow md:flex-1">
                            <label class="font-semibold mb-2 flex items-center gap-1"
                                >Capital Social outra UF
                                <i class="pi pi-history text-xs cursor-pointer" pTooltip="Histórico" tooltipPosition="top" (click)="abrirHistoricoCapitalSocial('M')"></i>
                            </label>
                            <p-input-number formControlName="capitalSocialOutraUf" inputId="capitalSocialOutraUf" mode="currency" currency="BRL" locale="pt-BR" class="w-full" />
                        </div>
                        <app-form-date-picker [control]="capitalSocialOutraUfAtualizacao" [label]="'Dt. Atualização Outra UF'" [id]="'capitalSocialOutraUfAtualizacao'"></app-form-date-picker>
                    </div>
                </app-card-content>

                <app-card-content [headerColor]="true" icon="pi pi-sitemap" title="Estrutura">
                    <div class="flex flex-wrap justify-end gap-2 mb-3">
                        @if (podeVerFiliais) {
                            <p-button label="Ver filiais" icon="pi pi-list" severity="secondary" size="small" [outlined]="true" (onClick)="abrirFiliais()" />
                        }
                        @if (podeZerarFiliais) {
                            <p-button
                                label="Zerar filiais"
                                icon="pi pi-trash"
                                severity="danger"
                                size="small"
                                [outlined]="true"
                                [loading]="zerandoFiliais()"
                                [appCan]="rolePrestadoresDadosGeraisEditar"
                                [appCanUf]="pessoa()?.uf"
                                (onClick)="confirmarZerarFiliais()"
                            />
                        }
                    </div>
                    <div class="flex flex-wrap gap-4 mb-3">
                        <div class="flex-1 min-w-fit sm:max-w-1/4">
                            <label class="font-semibold block mb-2">Único / Matriz / Filial</label>
                            <p-select appendTo="body" formControlName="tipoEstabelecimento" [options]="opcoesTipoEstabelecimento" optionLabel="label" optionValue="value" placeholder="Selecione" styleClass="w-full" />
                        </div>
                        <div class="flex-1 min-w-fit flex-grow md:max-w-[12rem]">
                            <label class="font-semibold block mb-2">Número de Filiais</label>
                            <p-input-number formControlName="numeroFiliais" locale="pt-BR" class="w-full" />
                        </div>
                        <div class="flex-1 min-w-fit sm:max-w-1/4">
                            <label class="font-semibold block mb-2">Matriz (código)</label>
                            <input pInputText formControlName="matrizCodigo" class="w-full" />
                        </div>
                        <div class="flex-1 min-w-fit sm:max-w-[8rem]">
                            <label class="font-semibold block mb-2">Matriz (UF)</label>
                            <input pInputText formControlName="matrizUf" class="w-full" />
                        </div>
                        <div class="flex-grow min-w-fit sm:flex-2">
                            <label class="font-semibold block mb-2">Matriz (descrição)</label>
                            <input pInputText formControlName="matrizDescricao" class="w-full" />
                        </div>
                    </div>
                    @if (isEditing && isTipoFilial) {
                        <div class="flex flex-wrap gap-2">
                            <p-button label="Selecionar matriz" icon="pi pi-search" severity="secondary" size="small" (onClick)="abrirPesquisaMatriz()" />
                            <p-button label="Remover matriz" icon="pi pi-times" severity="secondary" size="small" [outlined]="true" (onClick)="limparMatriz()" />
                        </div>
                    }
                </app-card-content>

                <app-card-content [headerColor]="true" icon="pi pi-briefcase" title="Mantenedora e Natureza">
                    <div class="flex flex-wrap gap-4 mb-3">
                        <div class="flex-grow md:flex-3">
                            <label class="font-semibold block mb-2">Mantenedora - Razão Social</label>
                            <input pInputText formControlName="mantenedoraRazaoSocial" class="w-full" />
                        </div>
                        <div class="flex-grow md:flex-2">
                            <label class="font-semibold block mb-2">Natureza Jurídica</label>
                            <p-select appendTo="body" formControlName="naturezaJuridicaMantenedor" [options]="opcoesNaturezaJuridicaMantenedor" optionLabel="label" optionValue="value" placeholder="Selecione" styleClass="w-full" />
                        </div>
                    </div>
                    @if (isEditing) {
                        <div class="flex flex-wrap gap-2">
                            <p-button label="Selecionar mantenedora" icon="pi pi-search" severity="secondary" size="small" (onClick)="abrirPesquisaMantenedora()" />
                            <p-button label="Remover mantenedora" icon="pi pi-times" severity="secondary" size="small" [outlined]="true" (onClick)="limparMantenedora()" />
                        </div>
                    }
                </app-card-content>
            </div>
        </app-card-content>
    </form>
</div>

<p-confirmDialog />

<p-dialog
    appDialogoPadrao="pi pi-users"
    descricao="Unidades vinculadas a este prestador."
    [visible]="filiaisDialogVisivel()"
    (visibleChange)="filiaisDialogVisivel.set($event)"
    [style]="{ width: 'min(94vw, 640px)' }"
    [appendTo]="'body'"
    header="Filiais"
>
    <p-table [value]="filiais()" [loading]="carregandoFiliais()" [scrollable]="true" scrollHeight="360px" styleClass="p-datatable-sm">
        <ng-template #header>
            <tr>
                <th class="w-24">Ações</th>
                <th>CRM</th>
                <th>UF</th>
                <th>Razão Social</th>
            </tr>
        </ng-template>
        <ng-template #body let-filial>
            <tr>
                <td><p-button icon="pi pi-external-link" severity="secondary" text rounded [disabled]="!filial.idSolicitante" (onClick)="abrirPrestador(filial)" /></td>
                <td>{{ filial.crm ?? '-' }}</td>
                <td>{{ filial.uf ?? '-' }}</td>
                <td>{{ filial.razaoSocial ?? filial.nomeFantasia ?? '-' }}</td>
            </tr>
        </ng-template>
        <ng-template #emptymessage>
            <tr>
                <td colspan="4" class="text-center">Nenhuma filial vinculada.</td>
            </tr>
        </ng-template>
    </p-table>

    <ng-template #footer>
        <p-button label="Fechar" severity="secondary" (onClick)="filiaisDialogVisivel.set(false)" />
    </ng-template>
</p-dialog>

<p-dialog
    appDialogoPadrao="pi pi-history"
    descricao="Alterações do capital social ao longo do tempo."
    header="Histórico de Capital Social"
    [visible]="capitalHistoricoDialogVisivel()"
    (visibleChange)="capitalHistoricoDialogVisivel.set($event)"
    [style]="{ width: 'min(94vw, 560px)' }"
    [appendTo]="'body'"
>
    <app-card-content [headerColor]="false" icon="pi pi-history" title="Histórico de Capital Social">
        <p-table [value]="capitalHistorico()" [loading]="carregandoCapitalHistorico()" [scrollable]="true" scrollHeight="360px" [showGridlines]="true" stripedRows styleClass="p-datatable-sm p-datatable-gridlines">
            <ng-template #header>
                <tr>
                    <th>Data da Atualização</th>
                    <th class="text-right">Valor do Capital Social</th>
                </tr>
            </ng-template>
            <ng-template #body let-item>
                <tr>
                    <td>{{ item.dtAtualizacao ? (item.dtAtualizacao | date: 'dd/MM/yyyy') : '-' }}</td>
                    <td class="text-right">{{ item.vrCapitalSocial != null ? (item.vrCapitalSocial | currency: 'BRL' : 'symbol' : '1.2-2' : 'pt-BR') : '-' }}</td>
                </tr>
            </ng-template>
            <ng-template #emptymessage>
                <tr>
                    <td colspan="2" class="text-center">Nenhum histórico encontrado.</td>
                </tr>
            </ng-template>
        </p-table>
    </app-card-content>

    <ng-template #footer>
        <p-button label="Fechar" severity="secondary" (onClick)="capitalHistoricoDialogVisivel.set(false)" />
    </ng-template>
</p-dialog>

<p-dialog
    appDialogoPadrao="pi pi-history"
    descricao="Renovações do certificado de regularidade."
    header="Histórico de Renovações do Certificado"
    [visible]="certificadoHistoricoDialogVisivel()"
    (visibleChange)="certificadoHistoricoDialogVisivel.set($event)"
    [style]="{ width: 'min(94vw, 640px)' }"
    [appendTo]="'body'"
>
    <app-card-content [headerColor]="false" icon="pi pi-history" title="Histórico de Renovações do Certificado">
        @if (isEditing) {
            <div class="mb-4">
                <form [formGroup]="renovacaoForm" class="flex flex-wrap items-end gap-3">
                    <app-form-date-picker [control]="renovacaoForm.get('dtRenovacao')" [id]="'renovacaoDtRenovacao'" [label]="'Data de Renovação'" />
                    <p-button label="Renovar certificado" icon="pi pi-check" size="small" [loading]="salvandoRenovacao()" [disabled]="renovacaoForm.invalid" (onClick)="salvarRenovacaoCertificado()" />
                </form>
                <small class="text-500">O ano e a data de validade são calculados automaticamente.</small>
            </div>
        }
        <p-table [value]="certificadoHistorico()" [loading]="carregandoCertificadoHistorico()" [scrollable]="true" scrollHeight="360px" [showGridlines]="true" stripedRows styleClass="p-datatable-sm p-datatable-gridlines">
            <ng-template #header>
                <tr>
                    <th>Ano</th>
                    <th>Data de Renovação</th>
                    <th>Data de Validade</th>
                </tr>
            </ng-template>
            <ng-template #body let-item>
                <tr>
                    <td>{{ item.nuAno ?? '-' }}</td>
                    <td>{{ item.dtRenovacao ? (item.dtRenovacao | date: 'dd/MM/yyyy') : '-' }}</td>
                    <td>{{ item.dtValidade ? (item.dtValidade | date: 'dd/MM/yyyy') : '-' }}</td>
                </tr>
            </ng-template>
            <ng-template #emptymessage>
                <tr>
                    <td colspan="3" class="text-center">Nenhuma renovação encontrada.</td>
                </tr>
            </ng-template>
        </p-table>
    </app-card-content>

    <ng-template #footer>
        <p-button label="Fechar" severity="secondary" (onClick)="certificadoHistoricoDialogVisivel.set(false)" />
    </ng-template>
</p-dialog>

<app-pesquisar-pessoa-custom [(showDialog)]="pesquisaMatrizVisivel" [tiposPessoaPermitidos]="['PRESTADOR']" (pessoa)="selecionarMatriz($event)" />

<app-pesquisar-pessoa-custom [(showDialog)]="pesquisaMantenedoraVisivel" [tiposPessoaPermitidos]="['PRESTADOR']" (pessoa)="selecionarMantenedora($event)" />

<app-prorrogar-prazo [(visible)]="prorrogarPrazoVisivel" [pessoa]="pessoa() ?? null" (concluido)="onPrazoProrrogado()" />

<app-alterar-situacao
    [(visible)]="situacaoCascataVisivel"
    [pessoa]="pessoa() ?? null"
    [situacaoAtual]="situacaoAtualId"
    [opcoes]="opcoesSituacaoFiltradas"
    [novaSituacaoInicial]="situacaoNovaCascata()"
    [dtSituacaoInicial]="dataSituacaoCascata()"
    (concluido)="onSituacaoCascataConcluida()"
/>
